import * as paymentActions from '../actions/payment.action';

export interface State {
  paidForAccommodation: boolean;
  paidForConference: boolean;
}

const initialState: State = {
  paidForAccommodation: false,
  paidForConference: false
};

export function reducer(
  state = initialState,
  action: paymentActions.paymentActions
) {
  switch (action.type) {
    case paymentActions.CHECK_ACCOMMODATION_PAYMENT: {
      const paidForAccommodation = action.payload;
      return {
        ...state,
        paidForAccommodation
      };
    }
    case paymentActions.CHECK_CONFERENCE_PAYMENT: {
      const paidForConference = action.payload;
      return {
        ...state,
        paidForConference
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/reducers/payment.reducer.ts